import { StFeatureFlagFlags } from '@/plugins/rollout';
import { createApi, logout } from '@stilingue/st-auth-utils';
import Service from '@/services/Service';

const version = StFeatureFlagFlags.UserLegacyServiceVersionProd.getValue();
const gateway = StFeatureFlagFlags.gatewayProd.getValue();

const afterParser = response => response.data;

export function error401Handler() {
  logout();
  window.location.reload();
}

export class UserLegacyService extends Service {
  constructor(gateway, version) {
    const api = createApi(`upms-legacy/${version}/user/`, gateway, { error401Handler });
    super(api, { afterParser });
  }

  me() {
    return this.find({ url: 'me' });
  }
}

export default new UserLegacyService(gateway, version);
